<script lang="ts">
	import Layout from "@components/layout/Layout.svelte";
	import OrganizationJsonLd from "@components/layout/OrganizationJsonLd.svelte";
	import ContactForm from "../components/ContactForm.svelte";
	import DeafultTwoColsWithImage from "../components/DeafultTwoColsWithImage.svelte";
	import EuProjectSection from "../components/EuProjectSection.svelte";
	import HomepageHero from "../components/HomepageHero.svelte";
	import Services from "../components/Services.svelte";
	import Arguments from "../components/WhyCooperate.svelte";
	import { getTranslate } from "../utils/getTranslate.js";
	import type { HomepageProps } from "./HomepageProps.js";
	import translations from "./default.translations.json" with { type: "json" };

	const { categories }: HomepageProps = $props();
	const translate = getTranslate(translations);
</script>

<OrganizationJsonLd />

<Layout>
	<HomepageHero />
	<Services {categories} />
	<Arguments />
	<DeafultTwoColsWithImage
		heading={translate("heading")}
		text={translate("text")}
		buttonText={translate("buttonText")}
	/>
	<EuProjectSection />
	<ContactForm heading="default" />
</Layout>
